import { Relationship } from "../enums/Relationship";
import { Medical } from "../enums/Medical";
import { WellnessScreeningType } from "../enums/WellnessScreeningType";
import { MannerOfDeath } from "../enums/MannerOfDeath";
import { ConditionType } from "../enums/ConditionType";
import { LeaveType } from "../enums/LeaveType";
import { getKeyByValue } from "../enums/KeyFinder";

export interface ClaimPlan {
    leaveType?: LeaveType,
    screeningType?: WellnessScreeningType,
    mannerOfDeath?: MannerOfDeath,
    conditionType?: ConditionType,
    displayedClaimType?: string,
    relationship: Relationship[],
    medical: Medical[]
}
export function filterLeaveTypesFor(leaveTypes: ClaimPlan[] | undefined, leaveRelationship: Relationship) {
    return leaveTypes?.filter(leavePlan => leavePlan.relationship.includes(leaveRelationship));
}

export function buildClaimTypeOptions(claimPlans: ClaimPlan[]) {
    return claimPlans
        .map(plan => {
            let claimType = '';
            let claimTypeEnum: typeof LeaveType | typeof WellnessScreeningType | typeof MannerOfDeath | typeof ConditionType = LeaveType;
            if (plan.leaveType) {
                claimType = plan.leaveType
                claimTypeEnum = LeaveType
            } else if (plan.screeningType) {
                claimType = plan.screeningType
                claimTypeEnum = WellnessScreeningType
            } else if (plan.mannerOfDeath) {
                claimType = plan.mannerOfDeath
                claimTypeEnum = MannerOfDeath
            } else if (plan.conditionType) {
                claimType = plan.conditionType
                claimTypeEnum = ConditionType
            }
            return {
                id: getKeyByValue(claimTypeEnum, claimType).replace(/_/g, '-').toLowerCase(),
                text: addSuperscriptTo(plan.displayedClaimType ?? claimType),
                value: claimType
            };
        }) ?? [];
}

function addSuperscriptTo(claimType: string) {
    const exclusions = [
        LeaveType.PERSONAL_OR_FAMILY_VIOLENCE,
        LeaveType.NICU_CARE,
        WellnessScreeningType.ANNUAL_PHYSICAL,
        WellnessScreeningType.ANY_OTHER_CANCER_SCREENING,
        WellnessScreeningType.BONE_DENSITY_SCREENING,
        WellnessScreeningType.HUMAN_PAPILLOMAVIRUS_SCREENING,
        WellnessScreeningType.IMMUNIZATION,
        WellnessScreeningType.ULTRASOUND_SCREENING_OF_ABDOMINAL_AORTA,
        WellnessScreeningType.DENTAL_PREVENTIVE_EXAMINATION,
        WellnessScreeningType.HEARING_SCREENING,
        WellnessScreeningType.HORMONE_REPLACEMENT_THERAPY,
        WellnessScreeningType.PRENATAL_PERINATAL_CARE,
        WellnessScreeningType.THYROID_PANEL
    ] as string[]
    const text = exclusions.includes(claimType) ? claimType + "¹" : claimType;
    if (!claimType) {
        throw new Error(`Invalid claim type: ${ text }`);
    }
    return text;
}